import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlSemen/imprimirControlSemen`, method: 'POST', body: values, token: token})
}